/* MIS Industrial — facets.js (collection + search templates)
   Enhances the plain GET filter/sort form with live Section Rendering
   updates. Without JS the form, chips, clear-all and pagination are ordinary
   links/submits and work fully. */

function announce(message) {
  const region = document.getElementById('A11yStatus');
  if (!region) return;
  region.textContent = '';
  window.setTimeout(() => { region.textContent = message; }, 50);
}

const region = document.querySelector('[data-results-region]');
const facetsRoot = document.querySelector('[data-facets]');
if (region && facetsRoot) {
  const sectionId = facetsRoot.dataset.sectionId;
  let controller = null;
  let debounceTimer = null;

  async function loadResults(url, { closeDrawer = false } = {}) {
    if (controller) controller.abort();
    controller = new AbortController();
    region.classList.add('results-loading');
    try {
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);
      const res = await fetch(fetchUrl, { signal: controller.signal });
      if (!res.ok) { window.location.href = url; return; }
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-results-region]');
      if (!fresh) { window.location.href = url; return; }

      const drawer = region.querySelector('details[data-drawer]');
      const wasOpen = drawer && drawer.open && !closeDrawer;
      region.replaceChildren(...fresh.childNodes);
      if (wasOpen) {
        const newDrawer = region.querySelector('details[data-drawer]');
        if (newDrawer) newDrawer.open = true;
      }
      document.body.style.overflow = '';

      const cleanUrl = new URL(url, window.location.origin);
      cleanUrl.searchParams.delete('section_id');
      window.history.pushState({}, '', cleanUrl);

      const count = region.querySelector('.facets__count');
      if (count) announce(count.textContent.trim());
      bindDrawer();
    } catch (err) {
      if (err.name !== 'AbortError') window.location.href = url;
    } finally {
      region.classList.remove('results-loading');
    }
  }

  function formToUrl(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (value !== '') params.append(key, value);
    });
    return `${form.getAttribute('action')}?${params.toString()}`;
  }

  region.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-facets-form]');
    if (!form) return;
    e.preventDefault();
    loadResults(formToUrl(form), { closeDrawer: true });
  });

  region.addEventListener('change', (e) => {
    const form = e.target.closest('[data-facets-form]');
    if (!form) return;
    if (e.target.type === 'number') return; // wait for Apply on price inputs
    window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(() => loadResults(formToUrl(form)), 350);
  });

  region.addEventListener('click', (e) => {
    const link = e.target.closest('.facet-chip, .pagination a');
    if (!link) return;
    e.preventDefault();
    loadResults(link.href);
    if (link.closest('.pagination')) {
      const heading = document.querySelector('h1');
      if (heading) heading.scrollIntoView();
    }
  });

  window.addEventListener('popstate', () => window.location.reload());

  /* Re-bind the details drawer inside refreshed HTML (global.js binds once at load). */
  function bindDrawer() {
    region.querySelectorAll('details[data-drawer]').forEach((details) => {
      if (details.dataset.bound) return;
      details.dataset.bound = 'true';
      const summary = details.querySelector('summary');
      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        document.body.style.overflow = details.open ? 'hidden' : '';
      });
      details.querySelectorAll('[data-drawer-close]').forEach((el) => {
        el.addEventListener('click', () => { details.open = false; });
      });
      details.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') details.open = false;
      });
    });
  }
  bindDrawer();
}
